import "./styles/default.less"
import './styles/desktop/Thesis2.less'

import * as React from "react"
import * as ReactDOM from "react-dom"
import * as mockxhr from "mockxhr"
import * as qs from "query-string"
import * as _ from 'lodash'
import * as util from "./util"
import Comments from "./components/Comments"
import Detail from "./components/ThesisDetail2"
import Footer from "./components/Footer2"
import Header3 from "./components/Header3"
import Media from "./components/Media"
import Partner from "./components/Partners2"
import Relevant from "./components/Relevant"
import ShareIcons from "./components/ShareIcons2"
import { Box, Item, Icon } from "./components"
import { actions } from "./flux"
import { Button, Dropdown, Menu, Icon as Aicon } from 'antd'

interface State {
    id: string
    item: any
    recommends: any[]
    column: any
    paperIndex: number
    paperTab: number
    countComment: number
    siblings: any[]
    periodicalData: any
    selectedPeriodicalIndex: number
    periodicalNameList: string[]
    periodical: any
    adItems: any[]
}

class View extends React.Component<{}, State> {
    root = document.querySelector("body>div#root") as HTMLElement

    constructor(props) {
        super(props)
        this.state = {
            id: util.getViewID(),
            item: null,
            recommends: [],
            column: {
                uid: "",
                description: "",
            },
            paperIndex: 0,
            paperTab: 0,
            countComment: 0,
            siblings: [],
            periodicalData: [],
            periodicalNameList: [],
            selectedPeriodicalIndex: 0,
            periodical: {},
            adItems: []
        }
        this.getPeriodicalData = this.getPeriodicalData.bind(this)
    }

    componentDidMount() {
        window.addEventListener("resize", () => this.setState({}))

        actions.api.thesis.get({ id: this.state.id }, item => {
            let hasMedia = false
            let hasColumn = false

            this.setState({ item })

            let periodicalNameList: string[] = []
            _.map(item.paperList, i => periodicalNameList.push(i.checkname))
            this.setState({periodicalNameList}, () => {
                mockxhr.POST(`/api/periodical/seaid`, {
                    query: this.state.periodicalNameList[this.state.selectedPeriodicalIndex]
                }, resp => {
                    this.setState({
                        periodical: resp.hits[0]
                    })
                })
            })

            this.getPeriodicalData()

            let column = (item.columns || [])[0]
            if (column) {
                // 同栏目文章
                actions.api.thesis.search({
                    from: 0, size: 4, type: "SEARCH",
                    request: {
                        filters: { columns: column },
                        sort: [{ onlineTime: "DESC" }],
                    }
                }, res => this.setState({ siblings: res.hits.filter(r => r.id !== this.state.id)}, () => {
                    hasMedia = !!this.state.item.source && !!this.state.item.source.sourceId
                    hasColumn = this.state.siblings.length > 0
                }))
            }
            
            // 滚动到广告底部时将periodical设为fixed
            let root: any = document.querySelector('#root')
            let periodical: any = document.querySelector('#periodical')
            let detail: any = document.querySelector('#detail-wrapper')

            if (root && periodical && detail) {
                root.addEventListener('scroll', () => {
                    if ((detail.clientHeight - 230) > root.scrollTop && root.scrollTop > ((hasMedia ? 380 : 0) + (hasColumn ? 410 : 250) + (this.state.adItems.length * 235) + 80)) {
                        periodical.style.position = 'fixed'
                        periodical.style.top = '80px'
                    } else if ((detail.clientHeight - 230) < root.scrollTop) {
                        periodical.style.position = 'fixed'
                        periodical.style.top = '-500px'
                    }else {
                        periodical.style.position = 'relative'
                        periodical.style.top = '0px'
                    }
                })
            }
        })

        mockxhr.POST("/api/promotions/search/IMAGE_ENTRY?" + qs.stringify({
            type: "_", from: 0, size: 100,
        }), {}, res => {
            this.setState({
                recommends: [
                    ...res.hits.filter(r => r.type1 === "INFORMATION").sort((a, b) => b.weight - a.weight),
                    ...res.hits.filter(r => r.type1 === "CAREER").sort((a, b) => b.weight - a.weight),
                ]
            })
        })

        // 获取广告数据
        mockxhr.POST("/api/promotions/search/AD?type=_&from=0&size=99", {}, res => {
            (res.hits || []).filter(r => {
                if (r.type === "AD" && r.type1 === "PC_DETAIL_1") this.state.adItems[0] = r
                if (r.type === "AD" && r.type1 === "PC_DETAIL_2") this.state.adItems[1] = r
                if (r.type === "AD" && r.type1 === "PC_DETAIL_3") this.state.adItems[2] = r
                this.setState({ adItems: this.state.adItems.filter(r => !!r) })
            })
        })
    }

    componentDidUpdate(preProps, preState) {
        if (preState.selectedPeriodicalIndex !== this.state.selectedPeriodicalIndex) {
            this.getPeriodicalData()
        }
        if ((preState.selectedPeriodicalIndex !== this.state.selectedPeriodicalIndex) && this.state.item) {
            mockxhr.POST(`/api/periodical/seaid`, {
                query: this.state.periodicalNameList[this.state.selectedPeriodicalIndex]
            }, resp => {
                this.setState({
                    periodical: resp.hits[0]
                })
            })
        }
    }

    getPeriodicalData() {
        if (this.state.item && this.state.item.id) {
            mockxhr.GET(`/api/theses/next?journals=${this.state.periodicalNameList[this.state.selectedPeriodicalIndex]}&id=${this.state.item.id}`, {}, resp => {
                this.setState({
                    periodicalData: resp
                })
            })
        }
    }

    recommend(i) {
        let item = this.state.recommends[i]
        if (!item) return null
        return (
            <Item flex style={{ marginTop: 24 }}>
                {util.imageMask(item.image, "100%", 152, () => actions.clickPromotion(item.id, item.link))}
                <div style={{ overflow: "hidden", fontSize: 16, lineHeight: "28px", maxHeight: 52, marginTop: 6 }}>
                    <a href={item.link} target="_blank" className="text-hover-primary">
                        {item.title}
                    </a>
                </div>
            </Item>
        )
    }

    relevant(i) {
        let item = this.state.item.relevant[i]
        return (
            <Item flex style={{ marginTop: 24 }}>
                <a href={item.source} target="_blank" className="text-hover-primary">
                    {util.imageMask(item.cover, "100%", 152, () => actions.clickPromotion(item.id, item.link))}
                    <div style={{ overflow: "hidden", fontSize: 16, lineHeight: "28px", maxHeight: 52, marginTop: 6 }}>
                        {item.target}
                    </div>
                </a>
            </Item>
        )
    }

    render() {
        if (!this.state.item) return null
        let { item, siblings, periodicalData, periodicalNameList, paperIndex } = this.state
        let column = (item.columns && item.columns[0]) || "前沿"
        let paperList = item.paperList || []
        let selectedPaper = paperList[this.state.paperIndex] || {}

        return (
            <Box vertical relative style={{ minHeight: "100%" }} className="min-view">
                <Header3 tab="THESIS" search="theses">
                    {_.map((paperIndex >= 3 ? paperList.slice(paperIndex - 2, paperIndex + 1) : paperList.slice(0, 3)), (itm, idx) => {
                        return (
                            <span 
                                className={`top-menu-item ${idx === paperIndex && 'top-menu-item-active'}`} 
                                onClick={() => {this.setState({ paperIndex: (idx + (paperIndex >= 3 ? (paperIndex - 2) : 0)) })}}
                            >
                                <span className='text'>
                                    {(idx + (paperIndex >= 3 ? (paperIndex - 2) : 0)) !== paperIndex && 
                                        (`论文${["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十"][(idx + (paperIndex >= 3 ? (paperIndex - 2) : 0))]}`)
                                    }
                                    {(idx + (paperIndex >= 3 ? (paperIndex - 2) : 0)) === paperIndex && 
                                        <p className='title'>
                                            {paperList.length === 1 ? 
                                                `论文：${itm.title}` :
                                                `论文${["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十"][(idx + (paperIndex >= 3 ? (paperIndex - 2) : 0))]}：${itm.title}`
                                            }
                                        </p>
                                    }
                                </span>
                                {(idx + (paperIndex >= 3 ? (paperIndex - 2) : 0)) === paperIndex && 
                                    <span className='button'>
                                        <Button style={{marginLeft: '36px'}} onClick={() => {
                                            actions.api.thesis.countOriPaperClickNum({id: item.id, paperId: selectedPaper.id, type: 'desktop'})
                                            window.open(selectedPaper.link)
                                            }}>阅读原文</Button>
                                    </span>
                                }
                            </span>
                        )
                    })}
                    {paperList.length > (paperIndex + 1) && (
                        <Dropdown overlay={
                            <Menu
                                style={{width: '120px'}}
                                onClick={({key}) => {
                                this.setState({paperIndex: parseInt(key) + (paperIndex >= 3 ? (paperIndex + 1) : 3)})
                            }}>
                                {_.map((paperIndex >= 3 ? paperList.slice(paperIndex + 1) : paperList.slice(3)), (item, index) => {
                                    return (
                                        <Menu.Item key={index}>
                                            <a>论文{["四", "五", "六", "七", "八", "九", "十", "十一", "十二", "十三", "十四", "十五", "十六", "十七", "十八", "十九", "二十"].slice(paperIndex >= 3 ? (paperIndex - 2) : 0)[(index)]}</a>
                                        </Menu.Item>
                                    )
                                })}
                            </Menu>
                        }>
                            <span className={`more ${this.state.paperIndex >= 3 && 'more-active'}`}>...</span>
                        </Dropdown>
                    )}
                </Header3>

                <div className="min-view-center bg-color-3">
                    <div>
                        <div className='breadcrumb' style={{ margin: "20px 0", fontSize: 12, color: "#333" }}>
                            您的位置：
                            <a className="border-block text-hover-primary" href="/">
                                领研网
                            </a>
                            {" > "}
                            <a className="border-block text-hover-primary" href="/theses">
                                论文
                            </a>
                            {column && " > "}
                            {column && <a className="border-block text-hover-primary"
                                href={`/searchall?filters.columns=${encodeURIComponent(column)}&tab=theses`}>
                                {column}
                            </a>}
                        </div>

                        <Box start>
                            <Box flex relative style={{ overflow: "hidden" }}>
                                {innerWidth < 1340 ?
                                    <div style={{ minWidth: 36 }}>
                                        <ShareIcons pic={item.cover} id={item.id} starType={"STAR_THESIS"} title={item.title} fixed
                                            description={util.htmlToPlain(item.content, true).substr(0, 64)}
                                            countComment={this.state.countComment} />
                                    </div>
                                    :
                                    <div style={{ position: "fixed", marginLeft: -60 }}>
                                        <ShareIcons pic={item.cover} id={item.id} starType={"STAR_THESIS"} title={item.title}
                                            description={util.htmlToPlain(item.content, true).substr(0, 64)}
                                            countComment={this.state.countComment} />
                                    </div>
                                }
                                {innerWidth < 1340 ? util.minWidth(24) : null}
                                <Item flex style={{ overflow: "hidden" }}>
                                    <div id="detail-wrapper">
                                        <Detail item={item} paperIndex={this.state.paperIndex} onSelectPaper={i => {this.setState({ paperIndex: i })}} />
                                    </div>

                                    {(!item.relevant || !item.relevant.length || !item.relevant.some(r => r.id)) ?
                                        null :
                                        <div>
                                            <div style={{ marginTop: 40, fontSize: 16, fontWeight: 700, lineHeight: 1 }}>
                                                相关推荐
                                            </div>
                                            <div style={{ marginTop: 24, padding: 24, paddingTop: 0, background: "white" }}>
                                                <Box>
                                                    {this.relevant(0)}
                                                    {util.minWidth(24)}
                                                    {this.relevant(1)}
                                                    {util.minWidth(24)}
                                                    {this.relevant(2)}
                                                </Box>
                                            </div>
                                        </div>
                                    }

                                    <div style={{ marginTop: 40, fontSize: 16, fontWeight: 700, lineHeight: 1 }}>
                                        为你推荐
                                    </div>
                                    <div style={{ marginTop: 24, padding: 24, paddingTop: 0, background: "white" }}>
                                        <Box>
                                            {this.recommend(0)}
                                            {util.minWidth(24)}
                                            {this.recommend(1)}
                                            {util.minWidth(24)}
                                            {this.recommend(2)}
                                        </Box>
                                        <Box>
                                            {this.recommend(3)}
                                            {util.minWidth(24)}
                                            {this.recommend(4)}
                                            {util.minWidth(24)}
                                            {this.recommend(5)}
                                        </Box>
                                    </div>

                                    <Comments id={item.id} style={{ marginTop: 24 }}
                                        onCommentUpdate={res => this.setState({ countComment: res.total })} />
                                </Item>
                            </Box>

                            {util.minWidth(24)}

                            <Item style={{ position: 'relative', width: 326 }}>
                                <Media sourceKey={item.sourceType !== "DEFAULT" && item.sourceKey} skipId={item.id} style={{ marginBottom: 24 }} />

                                <div id='column' style={{ background: "white", marginBottom: 24 }}>
                                    <div style={{ padding: 24, display: column ? "block" : "none" }}>
                                        <Box center style={{ fontWeight: 500 }}>
                                            <div style={{ fontSize: 16 }}>所属专栏</div>
                                            {util.minWidth(20)}
                                            <Item flex className="text-primary ellipsis" style={{ fontSize: 18 }}>
                                                {column}
                                            </Item>
                                        </Box>
                                    </div>

                                    {siblings.length > 0 ?
                                        <a target="_blank" href={"/theses/" + siblings[0].id}>
                                            <Box style={{ borderTop: "1px solid #f2f2f2", padding: 24, color: "#333" }}>
                                                {util.imageMask(siblings[0].cover, 102, 68, () => 0)}
                                                {util.minWidth(14)}
                                                <div className="link-hover"
                                                    style={{ maxHeight: 68, fontSize: 14, lineHeight: "23px", overflow: "hidden" }}>
                                                    {siblings[0].title}
                                                </div>
                                            </Box>
                                        </a>
                                        : null
                                    }
                                    {siblings.slice(1, 3).map(r =>
                                        <a target="_blank" href={"/theses/" + r.id}>
                                            <Box key={r.id} style={{ padding: "0 24px 18px" }}>
                                                <Icon name="caret right" className="text-primary" style={{ margin: "0 -0.25em" }} />
                                                {util.minWidth(10)}
                                                <Item flex className="link-hover"
                                                    style={{ fontSize: 14, lineHeight: "24px", overflow: "hidden", maxHeight: 50, color: "#333" }}>
                                                    {r.title}
                                                </Item>
                                            </Box>
                                        </a>
                                    )}

                                    {this.state.column.uid ?
                                        (<Box centerJustified style={{ padding: "0 24px 24px" }}>
                                            <a 
                                                className="text-primary" target="_blank"
                                                href={`/searchall?tab=theses&filters.columns=${encodeURIComponent(this.state.column.uid)}`}
                                                style={{ fontSize: 12, lineHeight: 1 }}>
                                                查看更多
                                            </a>
                                        </Box>) : null
                                    }
                                </div>

                                <div id='periodical' className='periodical-wrapper'>
                                    <div className='top'>
                                        <div className='title'>
                                            {/* <div className='name'>所属期刊</div> */}
                                            <div className='periodical'> 
                                                {_.map(_.uniq(periodicalNameList), (itm, idx) => <div key={itm} style={{fontStyle: (selectedPaper.type && selectedPaper.type === '期刊') ? 'italic' : 'normal'}} className={`item ${this.state.selectedPeriodicalIndex === idx && 'active'}`} onMouseOver={() => this.setState({selectedPeriodicalIndex: idx})}><div style={{display: this.state.selectedPeriodicalIndex === idx ? 'inline-block' : 'none'}} className='dot'/>{itm}</div>)}
                                            </div>
                                        </div>
                                        <div className='url'>
                                            <a target="_blank" href={this.state.periodical.url} onClick={() => { actions.api.thesis.countJournalOfficialSiteClickNum({id: item.id, paperId: selectedPaper.id, type: 'desktop'}) }}><Aicon type="desktop" />进入期刊官网</a>
                                            <a target="_blank" href={`/searchall?tab=theses&query=journals: ${encodeURIComponent(selectedPaper.checkname || selectedPaper.journal)}`}><Aicon type="read" />阅读本期刊更多导读</a>
                                        </div>
                                    </div>
                                    <div className='bottom'>
                                        {(periodicalData.down && periodicalData.down.id && periodicalData.down.title) && <div className='next block'>
                                            <p className='title'>下一篇</p>
                                            <div className='link' onClick={() => window.open(`/theses/${periodicalData.down.id}`)}>
                                                <Icon name="caret right" className="text-primary" style={{ margin: "0 -0.25em" }} />
                                                <span>{periodicalData.down.title}</span>
                                            </div>
                                        </div>}
                                        {(periodicalData.up && periodicalData.up.id && periodicalData.up.title) && <div className='pre block'>
                                            <p className='title'>上一篇</p>
                                            <div className='link' onClick={() => window.open(`/theses/${periodicalData.up.id}`)}>
                                                <Icon name="caret right" className="text-primary" style={{ margin: "0 -0.25em" }} />
                                                <span>{periodicalData.up.title}</span>
                                            </div>
                                        </div>}
                                    </div>
                                </div>

                                <Relevant relevant={item.relevant} hide />
                                {this.state.adItems.map((ad, i) =>
                                    <div key={i} style={{ marginBottom: i === this.state.adItems.length - 1 ? 0 : 24 }}>
                                        {util.imageMask(ad.image, "100%", 214, () => actions.clickPromotion(ad.id, ad.link))}
                                    </div>
                                )}
                            </Item>
                        </Box>

                        {util.minHeight(40)}
                    </div>
                </div>

                <Partner />
                <Footer />
            </Box>
        )
    }
}

ReactDOM.render(<View />, document.body.firstChild as any)
